import { createFileRoute } from "@tanstack/react-router"

import { SettingsPage } from "@/features/settings/components/settings-page"
import { requirePermissionRouteAccess } from "@/features/authz/require-permission-route-access"

export const Route = createFileRoute("/dashboard/settings/")({
	component: SettingsPage,
	beforeLoad: async ({ context }) => {
		await requirePermissionRouteAccess(context.queryClient, ["orders.read", "lab.ai.settings.read", "access.roles.read", "access.assignments.read"])
	},
})
